import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { videoSettingsInitialState } from './initialState';
import { type SettingsPaths, type VideoSettingsState } from './types';

const sideEffectHandlers: Partial<Record<SettingsPaths, (state: VideoSettingsState, value: any) => void>> = {
  'player.allowPause': (state, value: boolean) => {
    state.player.playPauseAnimation = value;
  },
  'controls.controlsVisibility': (state, value: 'onHover' | 'always' | 'hidden') => {
    if (value === 'hidden') {
      state.controls.hideProgressBar = true;
      // state.controls.hideVolumeControl = true;
      // state.controls.hidePlayButton = true;
      // state.controls.hideFullscreenButton = true;
      // state.controls.background = false;
    } else if (state.controls.controlsVisibility === 'hidden') {
      state.controls.hideProgressBar = false;
    }
  },
};

export const videoSettingsSlice = createSlice({
  name: 'videoSettings',
  initialState: videoSettingsInitialState,
  reducers: {
    setSettings(state, action: PayloadAction<VideoSettingsState>) {
      return action.payload;
    },

    updateSetting(state, action: PayloadAction<{ path: SettingsPaths; value: any }>) {
      const { path, value } = action.payload;

      if (sideEffectHandlers[path]) {
        sideEffectHandlers[path]!(state, value);
      }

      const segments = path.split('.');
      let obj: any = state;

      for (let i = 0; i < segments.length - 1; i++) {
        obj = obj[segments[i]];
      }

      obj[segments[segments.length - 1]] = value;
    },
  },
});

export const videoSettingsReducer = videoSettingsSlice.reducer;

export const { updateSetting, setSettings } = videoSettingsSlice.actions;
